{
  "SEARCH": {
    "TABS": {
      "ALL": "Mind",
      "CONTACTS": "Kontaktok",
      "CONVERSATIONS": "Beszélgetések",
      "MESSAGES": "Üzenetek"
    },
    "SECTION": {
      "CONTACTS": "Kontaktok",
      "CONVERSATIONS": "Beszélgetések",
      "MESSAGES": "Üzenetek"
    },
    "VIEW_MORE": "Továbbiak megtekintése",
    "LOAD_MORE": "Továbbiak betöltése",
    "SEARCHING_DATA": "Keresés",
    "LOADING_DATA": "Betöltés",
    "EMPTY_STATE": "Nem található {item}, a keresésre: '{query}'",
    "EMPTY_STATE_FULL": "Nincs eredménye a következő keresésnek: '{query}'",
    "PLACEHOLDER_KEYBINDING": "/ a fókuszáláshoz",
    "INPUT_PLACEHOLDER": "Search messages, contacts or conversations",
    "RECENT_MESSAGES": "Saját, nemrég küldött üzeneteim",
    "EMPTY_STATE_DEFAULT": "Search by conversation id, email, phone number, messages for better search results.",
    "BOT_LABEL": "Bot",
    "READ_MORE": "Tudj meg többet",
    "WROTE": "írta:",
    "FROM": "innen",
    "EMAIL": "e-mail",
    "EMAIL_SUBJECT": "tárgy"
  }
}
